// ONB-PARENT step 2: "Add your child" (R-0138). Shown right after the profile step for a parent who has no child yet. A parent who joined through a household invite (not the primary parent) skips it.
//   isDone  = a name (1+ characters) and a real date of birth (a date, not in the future, not more than 25 years back), like the Add-child modal's name + date of birth requirement.
//   commit  = ONE insert into children through the app's strict creator (_createChildStrict: it checks the error, then updates the local family exactly like the Add-child modal). Never twice: after a success the step is locked.
//   Skip    = nothing is written.
const H = () => window.HUD;
const T = (k, v) => H().T(k, v);
const el = (tag, cls, txt) => { const e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; };

export function dobOk(v, todayYmd) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(String(v || ''))) return false;
  const d = new Date(v + 'T00:00:00Z'); if (!Number.isFinite(d.getTime()) || d.toISOString().slice(0, 10) !== v) return false;
  const t = String(todayYmd || ''); if (!/^\d{4}-\d{2}-\d{2}$/.test(t)) return false;
  if (v > t) return false;                                          // not in the future
  const min = (Number(t.slice(0, 4)) - 25) + t.slice(4);            // not more than 25 years back
  return v >= min;
}
export function nameOk(v) { return String(v || '').trim().length >= 1; }
export function applicable(ctx) {
  const s = ctx && ctx.session; if (!s || s.role !== 'parent') return false;
  if (s.isPrimary === false) return false;                          // joined through a household invite: the family already exists
  return ((ctx.DB && ctx.DB.children) || []).length === 0;
}

export const childStep = {
  id: 'child', order: 20,
  applicable,
  label: () => T('onb_label_child'),
  summary: (r) => (r === 'done' ? T('onb_sum_child_done') : T('onb_sum_skipped', { label: T('onb_label_child') })),
  mount(api) {
    const h = H();
    const root = el('div');
    const ic = el('div', 'onb-icon', '🧒'); ic.setAttribute('aria-hidden', 'true');
    const title = el('h2'), sub = el('p', 'onb-sub');
    const fName = el('div', 'onb-field'), lName = el('label'), iName = el('input');
    iName.type = 'text'; iName.id = 'onb-child-name'; iName.maxLength = 60; iName.autocomplete = 'off'; lName.htmlFor = 'onb-child-name'; fName.append(lName, iName);
    const fDob = el('div', 'onb-field'), lDob = el('label'), iDob = el('input');
    iDob.type = 'date'; iDob.id = 'onb-child-dob'; lDob.htmlFor = 'onb-child-dob'; iDob.setAttribute('dir', 'ltr'); iDob.max = h._localToday ? h._localToday() : '';
    const dobErr = el('p', 'onb-hint-err'); dobErr.setAttribute('data-dob-error', '1'); dobErr.setAttribute('role', 'alert');
    fDob.append(lDob, iDob, dobErr);
    const lock = el('p', 'onb-note'); lock.hidden = true;
    const err = el('p', 'onb-error'); err.setAttribute('role', 'alert');
    root.append(ic, title, sub, fName, fDob, lock, err);
    let created = null;
    const today = () => (h._localToday ? h._localToday() : '');
    function texts() {
      title.textContent = T('onb_child_title'); sub.textContent = T('onb_child_sub');
      lName.textContent = T('onb_child_name_label'); iName.placeholder = T('onb_child_name_ph'); lDob.textContent = T('child_dob_label');
      dobErr.textContent = (!iDob.value || dobOk(iDob.value, today())) ? '' : T('onb_child_dob_invalid');
      if (created) lock.textContent = T('onb_child_locked');
    }
    texts();
    iName.addEventListener('input', () => api.refresh());
    iDob.addEventListener('input', () => { dobErr.textContent = (!iDob.value || dobOk(iDob.value, today())) ? '' : T('onb_child_dob_invalid'); api.refresh(); });
    iDob.addEventListener('change', () => { dobErr.textContent = (!iDob.value || dobOk(iDob.value, today())) ? '' : T('onb_child_dob_invalid'); api.refresh(); });
    return {
      el: root,
      isDone: () => !!created || (nameOk(iName.value) && dobOk(iDob.value, today())),
      async commit() {
        if (created) return { ok: true };                                // never a second insert
        const c = await h._createChildStrict({ canon: iName.value.trim(), alt: null, dob: iDob.value, emoji: '🌸', pronouns: null });
        if (!c) return { ok: false, error: T('onb_error_generic') };
        created = c; iName.disabled = true; iDob.disabled = true; lock.hidden = false; lock.textContent = T('onb_child_locked');
        return { ok: true };
      },
      onEnter() { if (!created && !iName.value) setTimeout(() => { try { iName.focus({ preventScroll: true }); } catch (_) {} }, 0); },
      relang: texts,
    };
  },
};
